<template>
  <div id="app">
    <div id="top-pane">
      <div id="graph">
        <svg pointer-events="all" :height="svgHeight" width="100%" :class="{zooming: zooming}"
          @click="previewed = highlightHomeIntro ? 'home' : undefined; acks = false;"
          @mousemove="mouseHasMoved = true"
          >
          <defs>
            <pattern v-for="node in graph.nodes" 
              :key="node.id"
              v-if="node.image"
              :id="node.id"
              x="0%" y="0%"
              height="100%"
              width="100%"
              viewBox="0 0 50 50">
              <rect height="100%" width="100%" fill="rgba(0, 20, 0, 1)" />
              <image x="0%" y="0%" width="50" height="50" :xlink:href="`/static/images/${node.id}.png`"/> 
            </pattern>
          </defs>
        <g class="everything" :transform="transform">
          <line v-for="(link, index) in graph.links" 
            v-if="(previewed == 'home' || (link.source.id != 'home' && link.target.id != 'home')) && (link.source.id == previewed || link.target.id == previewed)"
            :key="index"
            :x1="link.source ? link.source.x : 0"
            :y1="link.source.y"
            :x2="link.target.x"
            :y2="link.target.y"
            stroke="#fff"
            stroke-width="1.2"
          />

          <g v-for="node in graph.nodes" :key="node.id" 
            v-show="node.type!='Work' || foreground.has(node.id)"
            @mouseover="$event.stopPropagation(); if (/*node.type != 'Work' || foreground.has(node.id)*/ true) { highlightHomeIntro = !mouseHasMoved; previewed=node.id }"
            @click="$event.stopPropagation(); linkTo(node.id)"
            :class="{'graph-node': true, /*'invisible-work': node.type == 'Work' && (!previewed || !foreground.has(node.id)),*/ 'not-focused': previewed && previewed != 'home' && !foreground.has(node.id)}">
            <g v-if="node.type == 'Work'">
              <rect 
                v-if="false /*previewed==node.id*/"
                :stroke-width = "previewed==node.id ? 2 : 1" 
                :fill="(previewed==node.id) ? 'white' : 'black'"
                :stroke="(previewed==node.id) ? 'white' : 'black'"
                :x="node.x-(10 * node.rMod)"
                :y="node.y-(15 * node.rMod)" 
                :width="20*node.rMod"
                :height="30*node.rMod"/>
              <image
                :x="node.x-(10 * node.rMod)"
                :y="node.y-(15 * node.rMod)"
                :width="20*node.rMod"
                :height="30*node.rMod"
                :xlink:href="`/static/images/${node.id}.png`"
                />
                
            </g>
            <!-- <g v-else-if="node.type=='Module'"
              @mouseover="$event.stopPropagation(); highlightHomeIntro = !mouseHasMoved; previewed=node.id"
                @click="linkTo(node.id)">
              <circle 
                stroke-width = "(previewed==node.id) ? 2 : 1" 
                :fill="colorForNode(node)"
                :stroke="(previewed==node.id) ? 'white' : 'black'"
                :cx="node.x"
                :cy="node.y" 
                r="15"
                />
              <text v-if="node.type=='Module'" :x="node.x" :y="node.y+4" text-anchor="middle" font-size="15px" fill="white">{{node.title[0]+node.title[1]}}</text>
            </g> -->
            <g v-else>
            <text v-if="node.type=='Module'" :x="node.x" :y="node.y-radiusForNode(node)-5" text-anchor="middle" font-size="10px" letter-spacing="1.3" font-variant="small-caps" fill="rgba(246, 241, 225, 0.7)">{{node.title.toUpperCase()}}</text>
           
            <text v-if="node.type=='Keyword' && previewed==node.id"  :x="node.x" :y="node.y-radiusForNode(node)-5" text-anchor="middle" font-size="10px" fill="rgba(246, 241, 225, 0.7)">{{node.title}}</text>
            <circle
              :cx="node.x"
              :cy="node.y"
              :r="radiusForNode(node)"
              :stroke-width="0 /*(previewed==node.id) ? 2 : 0*/"
              :fill="colorForNode(node)"
              :stroke="(previewed==node.id) ? 'white' : 'black'" />
               <text v-if="!node.type" :x="node.x-15.5" :y="node.y+3" text-anchor="middle" font-size="10px" letter-spacing="1.3" font-variant="small-caps" fill="rgba(246, 241, 225, 0.7)">performance | theory</text>
            </g>
            </g>
          </g>
        </svg>
        <!-- <p><ul><li v-for="link in graph.links" :key="''+link.source+link.target">{{link.source.x}}</li></ul></p> -->
      </div>
      <transition name="fade">
        <div id="showInstr" @click="previewed = undefined" v-if="!readingView && previewed && previewed != 'home'">Show instructions</div>
      </transition>
      <div id="zoomButtons">
        <div id="zoomIn" @click="zoomBy(2)">+</div>
        <div id="zoomOut" @click="zoomBy(0.5)">-</div>
        <div id="refreshButton" @click="refresh">↻</div>
      </div>
      <div v-if="previewed && previewed != 'home' && !readingView" id="preview-panel">
        <div id="preview" @click="linkTo(previewed)">
          <h2>{{ entities[previewed].title }}</h2>
          <img v-if="entities[previewed].image" :src="`/static/images/${entities[previewed].id}.png`">
          <vue-markdown class="preview-text" :source="entities[previewed].overview" v-else-if="entities[previewed].overview" :postrender="x => postRender(x, entities[previewed].type)"/>
          <p class="typetag">{{ entities[previewed].type }}</p>
        </div>

        <div id="connections">
          <h3>Connections</h3>
          <ul>
            <li v-for="item in connections" :key="item"
              v-if="item != previewed && item != 'home'"
              :class="{ [entities[item].type] : true }"
              @click="translateTo(item); previewed = item">
              {{entities[item].title}}
            </li>
          </ul>
        </div>
      </div>
      <div v-else-if="!readingView" id="title-panel">
        <div id="title-div"><h2>Performance | Theory</h2></div>
        <div id="instructions">
          <div v-if="acks">
            <p style="padding:0 1.2em 0 1.2em">This site is made possible through the generous support of the <a href="http://ctl.unm.edu/">Center for Teaching and Learning</a> at the University of New Mexico.</p> 
            <p style="padding:0 1.2em 0 1.2em">Under the framework of the 2017-2019 Teaching Fellows Program, Dr. Dominika Laster (PI) led a community of practice—made up of faculty from across the College of Arts and Sciences and the College of Fine Arts—to conceptualize and develop the current site.</p> 
            <p style="padding:0 1.2em 0 1.2em">The website was designed and built by <a href="http://alexlew.net">Alex Lew</a>. Version 1 is still available <a href="http://v1.performancetheory.site">here</a>.</p>
          </div>
          <div v-else>
          <p style="padding: 0 1.2em 0 1.2em; text-align:center;">Welcome!</p> 
          <p style="padding: 0 1.2em 0 1.2em;">This interactive concept rhizome features short introductory modules on select theories, movements, relevant figures, and definitions of key terms. This evolving platform is intended as a point of departure for research, and is by no means exhaustive.</p> 
          <ul>
            <li><i>Click and drag</i> to pan.</li>
            <li><i>Scroll or double-click</i> to zoom.</li>
            <li>(Or use the + and - buttons in the lower left corner.)</li>
            <li><i>Mouse over</i> to preview.</li>
            <li><i>Click</i> on something to learn more.</li>
          </ul>
          </div>
        </div>
        
      </div>
      <div id="ackButton" @click="acks=!acks" v-if="(!previewed || previewed == 'home') && !readingView">{{acks ? 'Back' : 'Acknowledgments'}}</div>
    </div>
    <transition name="fade">
    <main v-if="readingView" :class="{'active': readingView}">
      <transition name="slide" mode="out-in">
        <router-view :key="$route.params.focused"></router-view>
      </transition>
    </main>
    </transition>
    <div v-if="readingView" id="closeButton" title="Back to map" @click="readingView=false">×</div>
  </div>
</template>

<script>
import content from '@/content'
import router from './router'
import * as d3 from 'd3';
import truncate from 'truncate-html';

let compareFn = (a, b) => {
  let [type1, type2] = [a.type, b.type]
  if (!type1 && !type2) { return 0 }
  if (!type1) { return -1 }
  if (!type2) { return 1  }
  if (type1 == type2) { return a.title < b.title ? -1 : (a.title == b.title ? 0 : 1) }
  if (type1 == 'Keyword' || type2 == 'Author' || (type1 == 'Module' && type2 != 'Keyword')) {
    return -1
  } else {
    return 1
  }
}

let entityIndices = {}
let nodes = []
let allIds = Object.keys(content.entities).filter(id => content.entities[id].type != 'Link').sort((a, b) => compareFn(content.entities[b], content.entities[a]))
allIds.forEach((id) => {
  entityIndices[id] = nodes.length
  nodes.push(Object.assign(content.entities[id], {id: id, index: nodes.length, rMod: Math.random() * .4 + 0.8, x: Math.floor(Math.random() * document.documentElement.clientWidth), y: Math.floor(Math.random() * document.documentElement.clientHeight)}))
})

let links = []
content.links.forEach(([source, target]) => {
  if (entityIndices[source] != undefined && entityIndices[target] != undefined) {
    links.push({source: entityIndices[source], target: entityIndices[target]})
  }
})

const graph = {
  nodes: nodes,
  links: links
}

export default {
  name: 'App',
  data () {
    return {
      previewed: this.$route.params.focused || 'home',
      entities: content.entities,
      graph: graph,
      transform: "translate(0, 0)",
      zooming: false,
      zoomer: null,
      defaultZoomTransform: null,
      fisheye: null,
      svgHeight: document.documentElement.clientHeight,
      svgWidth: document.documentElement.clientWidth,
      simulation: null,
      mouseHasMoved: false,
      highlightHomeIntro: true,
      readingView: this.$route.params.focused && this.$route.params.focused != 'home',
      acks: false
    }
  },
  computed: {
    connections () {
      if (!this.previewed) {
        return []
      }
  // Module and anything
  // Author and not module
  // Anything and Keyword
      let activeLinks = this.graph.links.filter((l) => l.source.id == this.previewed || l.target.id == this.previewed)
      let activeNodes = activeLinks.map((l) => l.source.id == this.previewed ? l.target.id : l.source.id)
      let sorted = activeNodes.filter(id => id != 'home').sort((a, b) => compareFn(this.entities[a], this.entities[b])).filter((x, i, a) => !i || x != a[i-1])
      return sorted
    },

    foreground () {
      if (!this.previewed) {
        return new Set()
      }

      let ret = new Set(this.connections)
      ret.add(this.previewed)
      return ret
    }
  },
  watch: {
    $route (to, from) {
      this.previewed = to.params.focused
      this.translateTo(this.previewed)
    }
  },
  mounted () {
    let that = this

    this.$nextTick(function() {
      window.addEventListener('resize', function () {
        that.svgHeight = document.documentElement.clientHeight
        that.svgWeidth = document.documentElement.clientWidth
      })});

    let centerX = (750 / this.svgHeight) * (this.svgWidth - 370) / 2
    let centerY = (this.svgHeight) / 2

    this.simulation = d3.forceSimulation(this.graph.nodes)
        .force('collideAuthors', d3.forceCollide(d => this.radiusForNode(d)+2))
        .force('charge', d3.forceManyBody().strength(d => -100))
        .force('link', d3.forceLink(this.graph.links))
        .force('x', d3.forceX(centerX))
        .force('y', d3.forceY(centerY))
    
    let svg = d3.select("#graph svg")

    let node = svg.selectAll('.graph-node')
          .data(this.graph.nodes)
          .call(d3.drag()
            .on("start", this.dragstarted)
            .on("drag", this.dragged)
            .on("end", this.dragended))

    this.zoomer = d3.zoom().on("zoom", function () {
      that.transform = d3.event.transform
    }).on("start", function() {
      that.startDragging()
    }).on("end", function() {
      that.zooming = false;
    }).filter(function() {
      var top  = window.pageYOffset || document.documentElement.scrollTop
      return (top == 0)
    })
    this.zoomer(svg)
    this.zoomer.scaleTo(svg, this.svgHeight / 750)
    this.defaultZoomTransform = d3.zoomTransform(svg.node())
  }, 
  methods: {
    refresh() {
      //router.push('/')
      this.previewed = 'home';
      this.graph.nodes.forEach(node => {
        node.x = Math.floor(Math.random() * document.documentElement.clientWidth)
        node.y = Math.floor(Math.random() * document.documentElement.clientHeight)
      })
      this.simulation.alpha(1).restart()
      
      this.zoomer.transform(d3.select("#graph svg").transition().duration(500), this.defaultZoomTransform)
      //location.reload()
    },
    radiusForNode (node) {
      const radii = {
        'Author': 20,
        'Module': 25,
        'Work': 15,
        'Keyword': 5
      }
      return (radii[node.type] || 10) * node.rMod
    },
    colorForNode (node) {
      if (node.image) {
        return "url(#" + node.id + ")" 
      }
      const colors = {
        'Module': '#389136',
        'Author': 'blue',
        'Work': 'green',
        'Keyword': '#59B053',
        'Link': 'pink'
      }
      return colors[node.type] || 'black'
    },
    linkTo(id) {
      this.readingView = true
      router.push(id)
      // setTimeout(() => this.previewed = undefined, 500)
      // setTimeout(function() {scrollTo(document.getElementsByTagName("main")[0].offsetTop, 600); that.simulation.restart() /*.scrollIntoView({ behavior: 'smooth', block: 'start' })*/}, 800)
    },
    translateTo(id) {
      this.zoomer.translateTo(d3.select("#graph svg").transition().duration(500), this.entities[id].x + 20, this.entities[id].y)
    },
    zoomBy(factor) {
      this.zoomer.scaleBy(d3.select("#graph svg").transition().duration(500), factor)
    },
    startDragging() {
      this.zooming = true
    },
    dragstarted(d) {
      if (!d3.event.active) this.simulation.alphaTarget(0.2).restart()
      d.fx = d.x
      d.fy = d.y
    },
    dragged(d) {
      d.fx = d3.event.x
      d.fy = d3.event.y
    },
    dragended(d) {
      if (!d3.event.active) this.simulation.alphaTarget(0)
      d.fx = null
      d.fy = null
    },

    postRender(text, kind) {
      return truncate(text, 200, {ellipsis: '... <p class="read-more">(click into this ' + kind.toLowerCase() + ' for more)</p>' })
    }

  }
}
</script>

<style>
svg {
  margin: 25px;
}

svg path {
  fill: none;
  stroke: #76BF8A;
  stroke-width: 3px;
}

html, body {
  height: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  background: #F0F0F0;
  min-width: 700px;
  width: 100%;
}
#app {
  font-family: 'Nunito Sans',  'Quattrocento',  'Concourse T3', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* font-size: 1.5em; */
  line-height: 1.3em;
  color: #3c4e60;
  width: 100%;
  min-width: 700px !important;
  height: 100%;
  display: flex;
  flex-direction: column;
}
#top-pane {
  position: relative;
  width: 100%;
  flex-shrink: 0;
  margin: auto;
  height: 100%;
  min-width: 700px !important;
  display: flex;
  flex-direction: row;
  /* background: url(http://performancetheory.site/assets/bg.jpg) lightseagreen; */
  /* background: url(https://jooinn.com/images/black-paper-texture-5.jpg); */
  /* background-image: linear-gradient(120deg, #d4fc79 0%, #96e6a1 100%); */
  /* background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%); */
  /* background-image: linear-gradient(to top, #96fbc4 0%, #f9f586 100%); */
  /* background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%); */
  /* background-image: linear-gradient(to top, #00c6fb 0%, lightseagreen 100%); */
  background-image: linear-gradient(to top, #0c7218, #648f40, #9ead6f, #d1d1a5); /*, #f6f1e1); */
  /*, #f6f1e1);*/
  /* background: url(https://images.pexels.com/photos/246212/pexels-photo-246212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260); */
  /* background: url(https://stmed.net/sites/default/files/tape-tension-pattern-wallpapers-25320-6152058.jpg); */
}

.graph-node {
  cursor: pointer;
}

#graph {
  min-width: 500px;
  width: 70%;
  flex-grow: 1;
  border-radius: 0 0 1em 0;
  /* background: black; */
}

#graph svg {
  margin: 0
}
#preview, #connections {
  z-index: 10;
  width: 330px;
  overflow-y: auto;
  padding: 10px;
  text-align: center;
  background: rgba(123, 209, 113, 0.7);
  border-radius: 4px;
  display: flex;
  margin-bottom: 20px;
  flex-direction: column;
  color: #333;
}

#preview {
  cursor: pointer;
  flex-shrink: 0;
}

#preview:hover {
  background: rgba(123, 209, 113, 0.9);
}

#title-panel, #preview-panel {
  position: absolute;
  z-index: 10;
  top: 5%;
  right: 20px;
  width: 350px;
  display: flex;
  flex-direction: column;
}

#title-div, #instructions {
  background: #7AD171;
  border-radius: 4px;
  color: #333;
  padding: 10px;
  text-align: center;
  margin-bottom: 20px;
}

#instructions {
  font-size: calc(0.9em + .5vh);
  line-height: 1.3em;
  padding-bottom: 40px;
  text-align: left;
}

#instructions ul {
  list-style-type: none;
  text-align: center;
  margin: 0;
  padding: 0;
}

#preview img {
  margin: auto;
  border-radius: 2px;
  max-height: 200px;
  max-width: 300px;
  margin-bottom: 10px;
}

#preview .typetag {
  margin: auto;
  text-align: center;
  padding: 0.2em 1em 0.2em 1em;
  border-radius: 10px;
  background: #0c7218;
  color: #F6EDD9;
  font-weight: bold;
  /* box-shadow: 2px 2px rgba(0, 74, 28, 0.2); */
  margin-bottom: 20px;
  margin-top: 20px;
}


main {
  padding-top: 5em;
  padding-right: 200px;
  padding-left: 5em;
  padding-bottom: 5em;
  background: rgba(240, 240, 240, 0.9);
  /* overflow-y: auto; */
  min-width: 200px;
  width: 100%;
  box-sizing:border-box;
  position: absolute;
  top: 0;
  left: 0;
  overflow-y: scroll;
  height: 100%;
  margin-bottom: 0;
  z-index: 20;
  transition: 0.5s;
  /* flex-grow: 1; */
}

.fade-leave-active {
  transition: 0.3s;
}
.fade-enter-active {
  transition: 0.4s;
  transition-delay: 0.4s;
}

.fade-enter {
  opacity: 0.0;
}

.fade-leave-to {
  opacity: 0;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.4s;
}
.slide-enter {
  opacity: 0.0;
}
.slide-leave-to {
  opacity: 0;
}

svg .not-focused {
  opacity: 0.2;
  transition: 0.5s;
}

svg {
  cursor: url('http://ssl.gstatic.com/ui/v1/icons/mail/images/2/openhand.cur'), move;
  /* background: rgba(0, 0, 0, 0.1); */
}

svg.zooming {
    cursor: url('http://ssl.gstatic.com/ui/v1/icons/mail/images/2/closedhand.cur'), move;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
}

.preview-text p {
  display: block;
  line-height: 1.3em;
  font-size: 1.2em;
  text-align: left;
  width: 300px;
  margin: auto;
  margin-bottom: 10px;
}

h1, h2 {
  line-height: 1.4em;
  margin-left: 10px;
  margin-right: 10px;
}

.preview-text p.read-more {
  font-size: 0.9em;
  color: black;
  font-weight: 100;
  text-align: center;

}

#closeButton {
  z-index: 50;
  color: gray;
  position: absolute;
  top: 50px;
  right: 50px;
  font-size: 3em;
  cursor: pointer;
  font-variant: small-caps;
  font-family: Helvetica;
}

#closeButton:hover {
  color: black;
  /* text-decoration: underline; */
}

.invisible-work, .not-focused.invisible-work {
  display: hidden;
  opacity: 0;
  cursor: inherit;
}

#preview-panel {
  height: calc(94vh);
  justify-content: space-between;
}

#connections {
  flex-grow: 1;
  height: 100%;
}

#connections ul {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* margin: auto; */
  margin: 0;
  padding: 0;
  overflow-y: scroll;
}

#connections li {
  display: block;
  padding: 7px;
  border-radius: 4px;
  border: dashed 1px rgb(48, 47, 47);
  margin-bottom: 10px;
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
  transition: 0.2s;
  font-size: 0.8em;
}

#connections li:hover {
  background: rgb(11, 182, 25);
  color: black;
}

#connections li.Work {
  font-style: italic;
}

#showInstr {
  position: absolute;
  left: 5vh;
  top: 5vh;
}

#zoomButtons {
  position: absolute;
  left: 5vh;
  bottom: 5vh;
  display: flex;
}

#showInstr, #zoomIn, #zoomOut, #refreshButton {
  background: rgba(0, 0, 0, 0.5);
  color: rgba(240, 240, 240, 0.5);
  border-radius: 6px;
  padding: 5px;
  cursor: pointer;
}

#showInstr:hover, #zoomIn:hover, #zoomOut:hover, #refreshButton:hover {
  background: rgba(0, 0, 0, 0.8);
  color: rgba(240, 240, 240, 0.8);
}

#showInstr:active, #zoomIn:hover, #zoomOut:hover, #refreshButton:hover {
  background: black;
}

#zoomIn, #zoomOut, #refreshButton {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  text-align: center;
  border-radius: 20px;
}

#ackButton {
  background: rgba(0, 0, 0, 0.5);
  color: #f6EDD9;
  padding: 5px;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  bottom: 5vh;
  right: 5vh;
  position: absolute;
  opacity: 0.7;
  width: 200px;
}

#ackButton:hover {
  opacity: 1;
}

#instructions a {
  color: blue;
}

#instructions a:active {
  color: darkblue;
}
</style>



// WEBPACK FOOTER //
// src/App.vue